import React, { createContext, useState, useContext } from 'react';

// Create the context
export const TranslateButtonContext = createContext();

// Create a provider component
export const TranslateButtonProvider = ({ children }) => {
  const [showTranslateButton, setShowTranslateButton] = useState(true);

  return (
    <TranslateButtonContext.Provider value={{ showTranslateButton, setShowTranslateButton }}>
      {children}
    </TranslateButtonContext.Provider>
  );
};

// Create a custom hook for easy access
export const useTranslateButton = () => useContext(TranslateButtonContext);
